import React from 'react';
import T from 'i18n-react';
import { useSelector } from 'react-redux';
import './Dashboard.css';
import PlainButton from '../../../../Controls/plainButton';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { trackEvent, HeapEvents } from '../../../../../utils/AnalyticsUtil';
import classNames from 'classnames';


const Greeting = (props) => {
    const firstLogin = useSelector(state => state.auth.firstLogin);
    const firstName = useSelector(state => state.accountData.firstName);
    const dispatch = useDispatch();
    const onStartNewReturn = () => {
        trackEvent(HeapEvents.BUTTON_START_NEW_TAXYEAR);
        dispatch(push('/dashboard/interview/year_selection'));
    }

    return (
        <div className={classNames('dashboard-greeting', props.layoutType)}>
            <h1>{T.translate(firstLogin ? 'Dashboard.labels.Hi' : 'Dashboard.labels.Welcome', { FirstName: firstName })}</h1>       
            {props.showCreateNewReturn && <PlainButton labelKey='WorkflowPanel.createNewReturn'  onClick={onStartNewReturn} inProgress={false} inverted={true} /> }
        </div>
    )
};

export default Greeting;